import { Button } from "./tailwind/button";
import { Text } from "./tailwind/text";
import { Gradient } from "./Gradient";
import { useSignOut } from "@gadgetinc/react";
import posthog from "posthog-js";

export const FallbackPage = () => {
  const signOut = useSignOut({ redirectToPath: "/dashboard" });

  return (
    <Gradient>
      <div data-testid="fallback-page" className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-2xl font-bold font-title leading-9 tracking-tight text-gray-900">
            You are not allowed on this page
          </h2>
        </div>

        <div className="mt-5 sm:mx-auto sm:w-full sm:max-w-[480px] z-20">
          <Text className="mt-10 text-center">Connect to another account?</Text>
        </div>
        <Button
          onClick={() => {
            signOut();
            posthog.reset();
          }}
          color="primaryButton"
          className="w-36 mx-auto mt-11"
        >
          Sign out
        </Button>
      </div>
    </Gradient>
  );
};
